import { DefaultError } from 'errors/DefaultError';
import { sendAdobeEvent } from 'analytics/sendAdobeData';

import type { ErrorResponse } from './types';
export class ApiError extends DefaultError {
  constructor({
    error,
    message,
    title
  }: {
    error?: ErrorResponse;
    message?: string;
    title?: string;
  }) {
    const response = error?.data ?? {};
    const status = error?.status;
    const url = error?.config?.url;
    const method = error?.config?.method?.toUpperCase();

    const shortMsg = `${method} ${url} ${status} (${error?.statusText})`;

    super({
      error: new Error(shortMsg),
      name: ApiError.name,
      message: message ?? shortMsg,
      title: title || ApiError.name,
      dd_fingerprint: shortMsg,
      context: {
        response,
        status,
        url,
        method
      }
    });

    this.response = error?.data ?? {};
  }

  protected sendAdobeEvent(eventData: Record<string, unknown>): void {
    sendAdobeEvent({ ...eventData, category: 'error' });
  }

  static get name() {
    return 'ApiError';
  }
}
